__turbopack_context__.v({
  "disabled": "bIKxvG_disabled",
  "iconButton": "bIKxvG_iconButton" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "iconWrapper": "bIKxvG_iconWrapper",
  "sizeM": "bIKxvG_sizeM",
  "sizeS": "bIKxvG_sizeS",
  "sizeXS": "bIKxvG_sizeXS",
  "title": "bIKxvG_title",
  "variantOverlayNeutral": "bIKxvG_variantOverlayNeutral",
  "variantSecondary": "bIKxvG_variantSecondary",
  "variantTransparentNeutral": "bIKxvG_variantTransparentNeutral",
});
